import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const products = [{
  image: 'https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=800&h=600&fit=crop',
  category: 'Surveillance',
  name: 'Ambient Cam-Eye Pro (Dome)',
  price: '$249.99',
  desc: '4K Ultra-HD monitoring with night vision.'
}, {
  image: 'https://images.unsplash.com/photo-1558002038-1055907df827?w=800&h=600&fit=crop',
  category: 'Access Control',
  name: 'Smart Fob Reader (clp_auth Integrated)',
  price: '$189.99',
  desc: 'Secure, encrypted entry for your facility.'
}, {
  image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop',
  category: 'Point of Sale',
  name: 'Zero-Fee POS Terminal',
  price: '$329.99',
  desc: 'Ditch the 3% Stripe & Toast charges. No hidden fees.'
}, {
  image: 'https://images.unsplash.com/photo-1582139329536-e7284fece509?w=800&h=600&fit=crop',
  category: 'Authentication',
  name: 'Multi-Format Fob Key (Pack of 5)',
  price: '$99.99',
  desc: 'Universal compatibility for all readers.'
}, {
  image: 'https://images.unsplash.com/photo-1596526131083-e8c633c948d2?w=800&h=600&fit=crop',
  category: 'Telephony',
  name: 'VoIP Desk Phone',
  price: '$149.99',
  desc: 'HD voice quality with cloud integration.'
}];
export function PricingSection() {
  return <section className="py-24 bg-[#F5F7F8]" id="pricing" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-269">
          <div className="max-w-2xl" data-id="element-270">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#011B33]" data-id="element-271">
              Pro-Grade Hardware, Smart Savings.
            </h2>
          </div>
          <button className="text-[#22A39F] font-bold flex items-center gap-2 hover:gap-3 transition-all group" data-id="element-272">
            View All Hardware
            <ArrowRightIcon className="w-4 h-4 transition-transform" data-id="element-273" />
          </button>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-274">
          {products.map((product, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100 flex flex-col group hover:shadow-xl hover:-translate-y-1 transition-all" data-id="element-275">
              <div className="h-48 overflow-hidden bg-slate-50" data-id="element-276">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-277" />
              </div>

              <div className="p-8 flex flex-col items-center text-center flex-grow" data-id="element-278">
                <div className="text-[10px] font-bold text-[#011B33] uppercase tracking-[0.2em] mb-2 opacity-60" data-id="element-279">
                  {product.category}
                </div>

                <h3 className="text-base font-bold text-[#011B33] mb-2 leading-tight min-h-[2.5rem] flex items-center justify-center" data-id="element-280">
                  {product.name}
                </h3>

                <p className="text-[11px] text-slate-500 mb-4 line-clamp-2" data-id="element-281">
                  {product.desc}
                </p>

                <div className="text-2xl font-black text-[#22A39F] mb-6" data-id="element-282">
                  {product.price}
                </div>

                <button className="mt-auto text-xs font-bold text-[#011B33] uppercase tracking-widest hover:text-[#22A39F] transition-colors" data-id="element-283">
                  View Details
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}